import DropdownButton from "react-bootstrap/esm/DropdownButton";
import { FC } from "react";
import { IDropdownPageProps } from "./IDropdownPageProps";
import { MUIIcon } from "../../../../widgets";
import { PartPage } from "../components";
import clsx from "clsx";

export const DropdownPage: FC<IDropdownPageProps> = ({
    title, icon, label, pageLink, className
}) => {
    return <>
        <DropdownButton
            variant="link"
            size="sm"
            bsPrefix={clsx("btn btn-link btn-sm", className)}
            title={<span title={title}>
                {icon && <MUIIcon iconName={icon} className="me-1" />}
                <span className="me-1">{label}</span>
            </span>}>
            {(pageLink?.pageId) && <>
                <PartPage
                    pageId={pageLink.pageId}
                    pageLink={pageLink}
                    className={className} />
            </>}
        </DropdownButton>
    </>
}